import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { isNil as _isNil } from 'lodash';
import { DisplayUnit, DisplayUnitArray } from '@blcloud/bl-datamodel/enum/managementreport/display-unit';
import { find as _find } from 'lodash';
/**
 * 数値または数値形式文字列を金額表記に変換するPipe
 * 金額表示単位：千円、百万円に対応する
 * それ以外の単位は一律千円表示となる
 * 数値は3桁毎にカンマ区切り
 */
@Pipe({ name: 'actualCurrency' })
export class ActualCurrencyPipe implements PipeTransform {

  /** 百万 */
  readonly ONE_MILLION = 1000000;
  /** 千 */
  readonly ONE_THOUSAND = 1000;

  /**
   * 変換要求を受け付ける
   * @param value 変換対象
   * @param unit 金額表示単位
   * @return 変換文字列
   */
  transform(value: string | number, amountUnit: string): string {
    if (value == null || amountUnit == null) {
      return;
    }

    // 金額変換の事前準備
    let transformValue = _isNil(value) ? '0' : value.toString();
    const denominator = amountUnit === DisplayUnit.HyakumanYen ? this.ONE_MILLION : this.ONE_THOUSAND;
    const suffix = _find(DisplayUnitArray, e => e.value === amountUnit).text;

    // 端数処理ファンクションを決定 (表示単位未満は切り上げ、表示単位以上は切り捨て)
    const roundingFn = Number(transformValue) < denominator ? Math.ceil : Math.floor;
    // 端数処理
    transformValue = String(roundingFn(Number(transformValue) / denominator));

    // 数値は3桁毎にカンマ区切り
    transformValue = new DecimalPipe('en-US').transform(transformValue, '1.0-2');
    return `${transformValue}${suffix}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/actual-currency.pipe.ts